import { cdnTemplate, jadeLocals } from 'cdnPreprocessor';

export default [
  'CartService',
  function ShoppingCartDir(cart) {
    return {
      restrict: 'E',
      scope: {
        toggle: '=?',
        scrollTo: '@?'
      },
      template: require('./shopping-cart.jade')(jadeLocals),
      link: (scope, element) => {
        if (typeof scope.toggle != 'boolean') {
          scope.toggle = 'na';
        }

        scope.cartTotals = cart.getTotals();

        if (scope.scrollTo) {
          let watcherSet = false;
          scope.$watch(() => cart.size(), (s, ss) => {
            // Don't run when this watcher is set.
            if (!watcherSet) {
              watcherSet = true;
              return;
            }

            if (s <= ss) return;

            $('html,body').animate({
              scrollTop: $(scope.scrollTo).offset().top
            }, 300);
          });
        }
      }
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/layout-components/shopping-cart/shopping-cart.dir.js